// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file medical_master/get_price_history.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PriceHistory } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetPriceHistoryRequest
 */
export class GetPriceHistoryRequest extends Message<GetPriceHistoryRequest> {
  /**
   * Unique identifier for the medical master record
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 2;
   */
  page = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<GetPriceHistoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPriceHistoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPriceHistoryRequest {
    return new GetPriceHistoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPriceHistoryRequest {
    return new GetPriceHistoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPriceHistoryRequest {
    return new GetPriceHistoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPriceHistoryRequest | PlainMessage<GetPriceHistoryRequest> | undefined, b: GetPriceHistoryRequest | PlainMessage<GetPriceHistoryRequest> | undefined): boolean {
    return proto3.util.equals(GetPriceHistoryRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetPriceHistoryResponse
 */
export class GetPriceHistoryResponse extends Message<GetPriceHistoryResponse> {
  /**
   * List of price history records
   *
   * @generated from field: repeated com.neulink.pharmacy.PriceHistory price_histories = 1;
   */
  priceHistories: PriceHistory[] = [];

  /**
   * Total number of price history records
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<GetPriceHistoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPriceHistoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "price_histories", kind: "message", T: PriceHistory, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPriceHistoryResponse {
    return new GetPriceHistoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPriceHistoryResponse {
    return new GetPriceHistoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPriceHistoryResponse {
    return new GetPriceHistoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPriceHistoryResponse | PlainMessage<GetPriceHistoryResponse> | undefined, b: GetPriceHistoryResponse | PlainMessage<GetPriceHistoryResponse> | undefined): boolean {
    return proto3.util.equals(GetPriceHistoryResponse, a, b);
  }
}

